var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvailable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icono-boton-accion") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boton-accion",
    transform: "translate(-17.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icono-accion-habilitado",
    transform: "translate(16.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2543FF",
    fillRule: "evenodd",
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61470741,14.2787468 L7.74168044,12.3613725 C7.34279507,11.9530428 6.6980494,11.9530428 6.29916403,12.3613725 C5.90027866,12.7697022 5.90027866,13.4307578 6.29916403,13.8380431 L8.8934492,16.4937527 C9.29233458,16.9020824 9.93708024,16.9020824 10.3359656,16.4937527 L16.500836,10.1829179 C16.8997213,9.7756325 16.8997213,9.11457699 16.500836,8.70624728 C16.1019506,8.29791757 15.4572049,8.29791757 15.0583196,8.70624728 L9.61470741,14.2787468 Z",
    id: "Fill-3",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailable);
export default __webpack_public_path__ + "static/media/available.2b33fb5f2d05fb7f0fc67860de116e06.svg";
export { ForwardRef as ReactComponent };